// Light / X-ray (dark) mode toggle — same behavior as the live site's #themeToggle:
// initializes from prefers-color-scheme, no persistence across loads (matches the
// site exactly). Wires up every .theme-toggle button found, since it can render
// once in the header or once on the password page, never both.
(function () {
  var buttons = document.querySelectorAll('.theme-toggle');
  if (!buttons.length) return;

  var prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  var dark = prefersDark;

  function apply() {
    buttons.forEach(function (btn) {
      if (dark) {
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Switch to normal view');
      } else {
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Switch to X-ray view');
      }
    });
    if (dark) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }

  apply();
  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      dark = !dark;
      apply();
    });
  });
})();
